import { createAction } from 'redux-actions';
import { fetchSubmissionAlert as fetchSubmissionAlertFromApi } from 'FormsUI/api/Alerts';
export const fetchSubmissionAlertRequest = createAction('alerts/FETCH_SUBMISSION_ALERT_REQUEST');
export const fetchSubmissionAlertResponse = createAction('alerts/FETCH_SUBMISSION_ALERT_RESPONSE');
export const fetchSubmissionAlert = () => dispatch => {
  dispatch(fetchSubmissionAlertRequest());
  return fetchSubmissionAlertFromApi().then(response => {
    dispatch(fetchSubmissionAlertResponse(response));
  }, error => dispatch(fetchSubmissionAlertResponse(error)));
};